// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 461 ? "webfontloader" : chunkId) + "." + {"461":"2b277969","490":"98f86e82","936":"bf43701c","960":"24d3b13c","983":"a0259cb7"}[chunkId] + ".js";
};